import React from 'react';

// Shared building blocks for the Login / Forgot / Reset password screens
// (styled by LoginPage.styles.js).

export function AuthWaves() {
  return (
    <svg
      className="login-waves"
      viewBox="0 0 1440 400"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="login-wave-front" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#3fbf86" />
          <stop offset="1" stopColor="#a6e0c5" />
        </linearGradient>
      </defs>
      <path
        className="login-wave-back"
        fill="#00a651"
        fillOpacity="0.12"
        d="M0 170 C220 90 380 130 600 175 C820 220 980 90 1200 110 C1320 120 1400 150 1440 135 L1440 400 L0 400 Z"
      />
      <path
        className="login-wave-mid"
        fill="#00a651"
        fillOpacity="0.2"
        d="M0 250 C200 175 360 215 580 250 C800 285 940 175 1160 195 C1290 207 1380 160 1440 150 L1440 400 L0 400 Z"
      />
      <path
        fill="url(#login-wave-front)"
        fillOpacity="0.95"
        d="M0 340 C180 285 330 270 520 295 C720 322 840 255 1040 240 C1240 225 1340 268 1440 215 L1440 400 L0 400 Z"
      />
    </svg>
  );
}

export function UserIcon() {
  return (
    <svg className="login-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-3.5 3.6-6 8-6s8 2.5 8 6" />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg className="login-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}
